/* Snuggz (11 Oct 2026, SAMI): free No Show sock with 2+ boxers. Shopper picks the size
   (snippets/snuggz-free-socks-note.liquid renders the picker); discount makes it Rs 0.
   Removes the sock when boxers drop below 2; no nagging after the shopper removes it. */
(function () {
  var SOCK_HANDLE = 'no-show-socks-black';
  var BOXER_TYPES = ['long boxers', 'short boxers', 'ball pouch boxers'];
  var K_AUTO = 'snzSockAuto', K_REMOVED = 'snzSockRemoved';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, origFetch = window.fetch.bind(window), html = document.documentElement;

  function isBoxer(i) { return BOXER_TYPES.indexOf(String(i.product_type || '').toLowerCase()) > -1; }
  function post(url, body) {
    return origFetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function syncFlag() { html.classList.toggle('snz-sock-dismissed', sessionStorage.getItem(K_REMOVED) === '1'); }
  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var d = document.querySelector('m-cart-drawer');
    if (d && d.onCartDrawerUpdate) d.onCartDrawerUpdate(true);
  }
  function check() {
    if (busy) return; busy = true;
    origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var boxers = 0, sockQty = 0, sockKey = null;
      cart.items.forEach(function (i) {
        if (isBoxer(i)) boxers += i.quantity;
        if (i.handle === SOCK_HANDLE) { sockQty += i.quantity; if (!sockKey) sockKey = i.key; }
      });
      var auto = sessionStorage.getItem(K_AUTO) === '1';
      if (boxers >= 2 && sockQty === 0 && auto) {           /* shopper removed the free sock */
        sessionStorage.setItem(K_REMOVED, '1'); sessionStorage.removeItem(K_AUTO); syncFlag();
      } else if (boxers < 2 && auto && sockKey) {
        sessionStorage.removeItem(K_AUTO);
        return post('cart/change.js', { id: sockKey, quantity: 0 }).then(function (r) { if (r.ok) refresh(); });
      } else if (auto && sockQty === 0) {
        sessionStorage.removeItem(K_AUTO);
      }
    }).catch(function () {}).then(function () { busy = false; });
  }
  /* 14 Oct 2026 (SAMI): don't re-render the drawer while the shopper is touching the sock picker,
     and ignore picker taps for 400ms after any re-render (the first tap used to miss). */
  var lastRender = 0, touching = false, pending = null;
  function wrapDrawer() {
    var d = document.querySelector('m-cart-drawer');
    if (!d || !d.onCartDrawerUpdate || d.__snzWrapped) return;
    var orig = d.onCartDrawerUpdate.bind(d); d.__snzWrapped = true;
    d.onCartDrawerUpdate = function () {
      var args = arguments;
      if (touching) { pending = function () { orig.apply(null, args); }; return; }
      return orig.apply(null, args);
    };
  }
  function bodyEl() { return document.querySelector('m-cart-drawer [data-minimog-cart-items]') || document.querySelector('[data-minimog-cart-items]'); }
  function watchRenders() {
    var b = bodyEl(); if (!b || b.__snzObs) return; b.__snzObs = true;
    new MutationObserver(function () { lastRender = Date.now(); }).observe(b, { childList: true });
  }
  function initGuards() { wrapDrawer(); watchRenders(); }
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('[data-snz-sock-picker]')) touching = true;
  }, true);
  function release() {
    if (!touching) return;
    setTimeout(function () { touching = false; if (pending) { var p = pending; pending = null; p(); } }, 400);
  }
  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-snz-sock-variant]');
    if (b && Date.now() - lastRender < 400) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-snz-sock-variant]');
    var reopen = e.target.closest && e.target.closest('[data-snz-sock-reopen]');
    if (reopen) { e.preventDefault(); sessionStorage.removeItem(K_REMOVED); syncFlag(); return; }
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-snz-sock-variant')), quantity: 1 }] }).then(function (r) {
      if (r.ok) { sessionStorage.setItem(K_AUTO, '1'); sessionStorage.removeItem(K_REMOVED); syncFlag(); refresh(); }
      else { btn.disabled = false; }
    }).catch(function () { btn.disabled = false; });
  });
  /* Re-check after any cart mutation (PerformanceObserver sees fetch/XHR even when apps wrap window.fetch) */
  var timer;
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(e.name)) { clearTimeout(timer); timer = setTimeout(check, 400); }
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (err) {}
  syncFlag();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGuards); else initGuards();
  window.addEventListener('load', initGuards);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
